// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__10dw9","content":"App_content__tFr1T","section":"App_section__2-L98"};